import {
  FETCH_ACCRUALS,
  FETCH_ACCRUALS_GRAPH_DATA,
  FETCH_ACCRUALS_INCOME,
  FETCH_TOTAL_ACCRUALS,
  SET_ACCRUALS,
  SET_ACCRUALS_GRAPH_DATA,
  SET_ACCRUALS_INCOME,
  SET_TOTAL_ACCRUALS,
} from './actionTypes';

export const fetchAccruals = (payload) => ({
  type: FETCH_ACCRUALS,
  payload: payload,
});

export const setAccruals = (data) => ({
  type: SET_ACCRUALS,
  payload: data,
});

export const fetchAccrualsIncome = () => ({
  type: FETCH_ACCRUALS_INCOME,
});

export const setAccrualsIncome = (data) => ({
  type: SET_ACCRUALS_INCOME,
  payload: data,
});

export const fetchTotalAccruals = (payload) => ({
  type: FETCH_TOTAL_ACCRUALS,
  payload: payload,
});

export const setTotalAccruals = (data) => ({
  type: SET_TOTAL_ACCRUALS,
  payload: data,
});

export const fetchAccrualsGraphData = (payload) => ({
  type: FETCH_ACCRUALS_GRAPH_DATA,
  payload: payload,
});

export const setAccrualsGraphData = (data) => ({
  type: SET_ACCRUALS_GRAPH_DATA,
  payload: data,
});
